export default function Logo({ className = "", showWord = true, size = "md" }) {
  // White-element transparent PNG sits inside a stone-900 disc so it appears as designed
  const sizeMap = {
    sm: { wrap: "h-10 w-10", img: "h-9 w-9" },
    md: { wrap: "h-11 w-11", img: "h-10 w-10" },
    lg: { wrap: "h-14 w-14", img: "h-13 w-13" },
  };
  const s = sizeMap[size] || sizeMap.md;

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <div className={`${s.wrap} rounded-full bg-stone-900 flex items-center justify-center shrink-0 overflow-hidden`}>
        <img
          src="/brand/bigibila-logo.png"
          alt="Bigibila Systems"
          className={`${s.img} object-contain`}
        />
      </div>
      {showWord && (
        <div className="leading-none">
          <div className="font-display font-bold tracking-tight text-[15px] text-stone-900">
            BIGIBILA
          </div>
          <div className="text-[9px] tracking-[0.32em] uppercase text-stone-500 mt-0.5">
            Systems™
          </div>
        </div>
      )}
    </div>
  );
}
